// extracted by mini-css-extract-plugin
module.exports = {"bryxHeader":"bryxHeader","white":"white","red":"red","inModal":"inModal","pageHeader":"pageHeader"};